import { Modal } from "antd";
import { ClockCircleOutlined, CreditCardOutlined, WarningOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { Card, CardBody } from "react-bootstrap";
import { validateTransaction } from "../services/developerApi";
import { useState } from "react";
const DetailTransactionBusiness = ({ isOpen, toggle, selectedTransaction }) => {
  const [loading, setLoading] = useState(false);
  if (!selectedTransaction) return null;
  const {
  transactionId,
    status,
    convertedAmount,
    transactionDate,
    paymentMethodName,
    amount,
    realAmount,
    currency,
    transactionReference,
  } = selectedTransaction;
  const formatDate = (timestamp) => dayjs(Number(timestamp)).format("DD-MM-YYYY");
  const handleReject = async () => {
  try {
    //await rejectTransaction(); // appel API
    toggle(); // 🔥 ferme après succès
  } catch (e) {
    console.error(e);
  }
};

const handleValidate = async () => {
  try {
    setLoading(true);
    await validateTransaction(transactionId);
    toggle();
  } catch (e) {
    console.error(e);
  } finally {
    setLoading(false);
  }
};
 return (
  <Modal
    open={isOpen}
    onCancel={toggle}
    footer={null}
    centered
    width={500}
    className="modal-detail-payment"
  >
    <h2 className="modal-title">Détails paiement</h2>
  <div className="modal-title" style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
  <Card 
    style={{ 
      width: 215, 
      height: 60, 
      borderRadius: 10, 
      background: "#FBF3FF", 
      border: "1px solid #F2D7FF",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 10px"
    }}
  >
    <CardBody style={{ display: "flex", alignItems: "center", gap: "10px", padding: "0" }}>
      <span 
        style={{
          backgroundColor: "#F1D5FF",
          width: "30px",
          height: "30px",
          borderRadius: "30%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ClockCircleOutlined style={{ color: "#9315D6",fontSize:'15px' }} />
      </span>
      <span style={{ fontWeight: 600, fontSize: 14, color: "#9315D6" }}>
    {status === "PENDING"
    ? "En attente de validation"
    : status === "PROCESSED"
    ? " Paiement validé"
    : "Échec"
    }
  </span>
  </CardBody>
  </Card>
</div>
<Card style={{ width: "100%", height: 80, borderRadius: 10, background: "#E5E7EB", border:"none" }}className="mb-3">
            <CardBody>
  <div style={{ display: "flex", flexDirection: "column" }}>
    <div
      style={{
        fontWeight: 600,
        fontSize: 12,
        color: "#99A1AF",
        marginBottom: "1px"
      }}
    >
      Détail de la transaction - {dayjs(transactionDate).format("DD-MM-YYYY")}
    </div>
    <div
      style={{
        width: "100%",
        height: "1px",
        backgroundColor: "#F9FAFB",
        margin: "5px 0"
      }}
    />
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}
    >
      <span style={{ color: "#364153", fontSize: 14,fontWeight:600 }}>
        Paiement effectué
      </span>
      <span style={{ fontWeight: 600, fontSize: 14,color: "#364153" }}>
        {convertedAmount} {currency}
      </span>
    </div>
  </div>
</CardBody>
  </Card>
  <div style={{ fontWeight: 600, fontSize: 12,color: "#99A1AF" }}className="mb-2">DÉTAILS PAIEMENT</div>
  <Card style={{ width: "100%", height: 70, borderRadius: 10, background: "#FFFFFF", border:"1px solid #E5E7EB" }}>
    <CardBody>
  <div
  style={{
    display: "flex",
    alignItems: "center", 
    gap: "10px",        
  }}
>
  <span
    style={{
      backgroundColor: "#F9FAFB",
      width: "30px",
      height: "30px",
      borderRadius: "30%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0, 
    }}
  >
    <CreditCardOutlined style={{ color: "#B3BCCC", fontSize: "15px" }} />
  </span>
  <div>
    <div
      style={{
        fontWeight: 400,
        fontSize: 10,
        color: "#99A1AF",
      }}
    >
      numéro de carte
    </div>
    <div style={{ fontWeight: 600,color:'#1E2939',fontSize:14 }}>
      **** **** **** 1234
    </div>
  </div>
</div>
</CardBody>
  </Card>
      <div className="payment-details" style={{ marginTop: '20px' }}>
      <div className="payment-row">
      <span className="label">ID Transaction</span>
      <span className="value">{transactionId}</span>
      </div>
    </div>
     <Card className="mb-4"style={{ width: "100%", height: 40, borderRadius: 10, background: "#FFF7ED", border:"none" }}>
    <CardBody style={{ padding: "2px 5px" }}>
  <div
  style={{
    display: "flex",
    alignItems: "center", 
    gap: "10px",        
  }}
>
  <span
    style={{
      backgroundColor: "#FFF7ED",
      width: "30px",
      height: "30px",
      borderRadius: "30%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0, 
    }}
  >
    <WarningOutlined  style={{ color: "#FF6900", fontSize: "15px" }} />
  </span>
  <div>
    <div
      style={{
        fontWeight: 400,
        fontSize: 12,
        color: "#CA3500",
      }}
    >
     Ce paiement n’est pas encore inclus dans le solde.
    </div>
  </div>
</div>
</CardBody>
  </Card>
 <button
        className="mb-2"
        style={{
                  backgroundColor:"#396AFC",
                  color:"#FFFFFF",
                  padding: "5px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                  width:"100%",
                }}
            onClick={handleValidate}
          >{loading ? "Validation..." : "Valider le paiement"}
          </button>
           <button
           style={{
                  backgroundColor:'#F2F5FF',
                  color: '#396AFC',
                  padding: "5px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                  width:"100%"
                }}
           onClick={ handleReject} 
           disabled={loading}
           >
            Rejeter
          </button>
  </Modal>
);
};

export default DetailTransactionBusiness;
